import React, { FC, ElementType, CSSProperties } from "react";
import { withThemeProvider, useTheme } from "@narvar/nth-hook-theme";

import IconButton from "@narvar/nth-bit-icon-button";

export type IconFilledButtonProps = {
  Icon: ElementType<{ s?: CSSProperties }>;
  hover?: boolean;
  onClick?: () => void;
  ariaLabel?: string;
  s?: CSSProperties;
  sHover?: CSSProperties;
  sIcon?: CSSProperties;
};

const IconFilledButton: FC<IconFilledButtonProps> = ({
  Icon,
  s,
  sHover,
  sIcon,
  ...props
}) => {
  const theme = useTheme();
  const { color, fill, ...iconStyle } = theme.iconsPrimaryNone ?? {};
  const backgroundColor: string = fill ?? color ?? "#000";

  return (
    <IconButton
      s={
        {
          background: backgroundColor,
          padding: "0.25rem",
          borderRadius: "50%",
          "&:hover": {
            background: backgroundColor,
            opacity: 0.3,
            ...sHover,
          },
          ...s,
        } as CSSProperties
      }
      {...props}>
      <Icon
        s={
          {
            display: "block",
            fill: "#fff",
            color: "#fff",
            ...iconStyle,
            ...sIcon,
          } as CSSProperties
        }
      />
    </IconButton>
  );
};

export default withThemeProvider(IconFilledButton, {
  themeTokens: ["iconsPrimaryNone"],
});
